import React from 'react'
import { useAccess } from 'contexts/access'
import { HeroColumns, TitleColumns } from './s'
import ModuleTitle from 'components/module-title'
import ExportUsers from 'pages/people/hero/export-users'
import RevisionGroupsPanel from 'pages/salary/panels/revision-groups'

const SalaryHero = () => {
    const { checkFeature } = useAccess()

    const salaryReviewersAvailable = checkFeature('salary-revision-reviewers')

    return (
        <HeroColumns>
            <ModuleTitle
                which="salary-revision"
                title={{
                    id: 'noun_salary',
                    defaultMessage: 'Salary'
                }} />
            <TitleColumns>
                {!!salaryReviewersAvailable && <RevisionGroupsPanel />}
                <ExportUsers salt="salary" />
            </TitleColumns>
        </HeroColumns>
    )
}

export default SalaryHero
